import { render, staticRenderFns } from "./InfectiousAssessment.vue?vue&type=template&id=580741a7"
import script from "./InfectiousAssessment.vue?vue&type=script&lang=js"
export * from "./InfectiousAssessment.vue?vue&type=script&lang=js"
import style0 from "./InfectiousAssessment.vue?vue&type=style&index=0&id=580741a7&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports